export * as Mutations from './mutations'
export * as Queries from './queries'
